import React from 'react'

function RecallHoursText({clinicHours}) {
  return (
    <div>
        <table className="table table-striped">
            <tbody>
                {clinicHours.map((item, index) => (
                    <tr key={index}>
                        <td className='ps-3'>{item.day}</td>
                       
                        <td>
                            <div className="d-flex flex-column">
                                <span>{item.start} - {item.end}</span>
                                <span>{item.note}</span>
                            </div>
                        </td>
                        
                    </tr>
                ))}
            </tbody>
        </table>
    </div>
  )
}

export default RecallHoursText